var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered",attrs:{"id":"keymapItem"}},[_c('button',{staticClass:"button is-small is-outline",attrs:{"disabled":!_vm.enabled},on:{"click":_vm.buttonClicked}},[_vm._v("\n    "+_vm._s(_vm.from)),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.to))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4df36fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/translit/src/components/keymapItem.vue
// module id = null
// module chunks = 